// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.WaybillNumber[data-v-0cf3007c] {\n  color: #409eff;\n  cursor: pointer;\n}\n.queryFormClass .el-form-item--mini.el-form-item[data-v-0cf3007c],\n.queryFormClass .el-form-item--small.el-form-item[data-v-0cf3007c] {\n  margin-bottom: 5px;\n}\n.ml[data-v-0cf3007c] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
